import {Injectable} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Injectable()
export class ReceiverValidatorService {
    getRowValidator(): FormGroup {
        return new FormGroup({
            'idDocType': new FormControl(null, Validators.required),
            'idDocNumber': new FormControl(null, Validators.required),
            'businessName': new FormControl(),
            'address': new FormControl(),
            'department': new FormControl(),
            'province': new FormControl(),
            'district': new FormControl(),
            'countryCode': new FormControl(),
            'phone': new FormControl(),
            'email': new FormControl(),
        });
    }

}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/servicios/ReceiverValidatorService.ts